import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'VariableFilterPipe'
})
export class VariableFilterPipe implements PipeTransform {

  transform(variables: Array<string>, filter: string): any {
    return variables.filter(l => l.indexOf(filter)!=-1);
  }

}
